import React, {Component} from 'react';

import logo from "../../img/logo.png";
import {Link} from "react-router-dom";
import axios from "axios";
import AuthService from "../../AuthService";
import authService from "../../AuthService";

class Layout extends Component {

    constructor(props) {
        super(props);
        this.props = props;

        this.state = {
            anomaliesNumber: 0,
            isCapitaine: false
        }
    }

    componentDidMount() {
        this.loadData();
    }

    async loadData() {
        await axios.post(AuthService.getUrl('/getNotifications'), {}, AuthService.getAuthHeader()).then(res => {
            this.setState({
                anomaliesNumber: res.data.data['anomalieNumber']
            });
        });

        authService.getUserById().then(res => {
            const isCapitaine = res.data.data.capitaine === "oui";

            this.setState({
                isCapitaine: isCapitaine
            });
        });
    }

    disconnect(){
        authService.disconnect();
        window.location.replace("/admin");
    }

    render() {
        return (
            <React.Fragment>
                <div id="sideBar">
                    <img id="logo" alt="Green River Cruises" src={logo}/>
                    <div id="menu">
                        <div className="itemGroup">Croisières</div>
                        <Link id="item-1" className="item" to="/admin/reservations">Réservations</Link>
                        <Link id="item-2" className="item" to="/admin/calendriers">Calendrier</Link>
                        <a id="item-12" className="item" href="https://paiement.systempay.fr/vads-merchant/loginAction"
                           target="_blank"> Paiements</a>
                        <Link id="item-12" className="item" to="/admin/extras">Extras</Link>
                        {!this.state.isCapitaine && (
                            <React.Fragment>
                                <div className="itemGroup">Flotte</div>
                                <Link id="item-7" className="item" to="/admin/utilisateurs">Capitaines</Link>
                                <Link id="item-3" className="item" to="/admin/flotte">Flotte</Link>
                                <Link id="item-3" className="item" to="/admin/villes">Villes</Link>
                                {/*<Link id="item-6" className="item" to="/admin/observations">Observations</Link>*/}
                                <Link id="item-4" className="item"
                                      to="/admin/anomalies">{'Anomalies (' + this.state.anomaliesNumber + ')'}</Link>
                                <Link id="item-5" className="item" to="/admin/maintenances">Tâches de maintenance</Link>
                                <div className="itemGroup">Paramétrage</div>
                                <Link id="item-9" className="item" to="/admin/croisiereTypes">Types de croisière</Link>
                                <Link id="item-10" className="item" to="/admin/eventTypes">Types d'évenement</Link>
                                <Link id="item-10" className="item" to="/admin/options">Options</Link>
                                <Link id="item-10" className="item" to="/admin/ramassages">Ramassages</Link>
                                <Link id="item-10" className="item" to="/admin/anomalieMaintenanceTypes">Types
                                    d'anomalie /
                                    maintenance</Link>
                                <Link id="item-11" className="item" to="/admin/labels">Labels</Link>
                                <Link id="item-12" className="item" to="/admin/mailsTemplates">Mails Templates</Link>
                            </React.Fragment>
                        )}
                        <div className="logout-button">
                            <button type="submit" onClick={() => this.disconnect()}>Déconnecter</button>
                        </div>
                    </div>
                </div>
                <div id="bodyContent">
                    {this.props.children}
                </div>
            </React.Fragment>
        );
    }
}

export default Layout;
